import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { areDatesDisabledForReport } from '../utils/helpers';
import { AdvertisersFieldMui } from './components/AdvertisersFieldMui';
import { CampaignsField } from './components/CampaignsField';
import { CustomFields } from './components/custom-fields/CustomFields';
import { CustomIdsField } from './components/custom-fields/CustomIdsField';
import { FromField } from './components/FromField';
import { GipStationsField } from './components/GipStations';
import { OrdersField } from './components/orders/OrdersField';
import { ToField } from './components/ToField';
import { VersionsField } from './components/VersionsField';
import { GipReportValues } from './types';

export const GipReportForm = () => {
  const fp = useFormikContext<GipReportValues>();

  return (
    <Grid container p={2}>
      {!areDatesDisabledForReport(fp.values) && (
        <Grid container>
          <Grid item xs={12} md={6}>
            <FromField />
          </Grid>
          <Grid item xs={12} md={6}>
            <ToField />
          </Grid>
        </Grid>
      )}

      <Grid container>
        <Grid item xs={12}>
          <GipStationsField />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} md={6}>
          <AdvertisersFieldMui />
        </Grid>
        <Grid item xs={12} md={6}>
          <CampaignsField />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} md={6}>
          <VersionsField />
        </Grid>
        <Grid item xs={12} md={6}>
          <OrdersField />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} md={6}>
          <CustomFields />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomIdsField />
        </Grid>
      </Grid>
    </Grid>
  );
};
